import {Component, OnDestroy, OnInit, ViewChild, ViewEncapsulation} from '@angular/core';
import {SearchCriteria} from '../../../../model/search-criteria';
import {DateFiltered, SearchService} from '../../../../services/apiServices/business/search.service';
import {TranslateService} from '@ngx-translate/core';

import {SelectItem} from 'primeng/api';
import {UpdateSearchFiltersService} from '../../../../services/crossComponent/update-search-filters.service';
import {CustomDate} from '../../../../model/custom-date';
import {DatePipe, registerLocaleData} from '@angular/common';
import localeFr from '@angular/common/locales/fr';
import localeFrExtra from '@angular/common/locales/extra/fr';
import localeEn from '@angular/common/locales/en';
import localeEnExtra from '@angular/common/locales/extra/en';
import {User} from '../../../../model/user';
import {AuthenticationService} from '../../../../services/apiServices/security/authentication.service';
import {StorageService} from '../../../../services/storage/storage.service';
import * as moment from 'moment';
import {Calendar} from 'primeng/calendar';
import {FileSaverService} from 'ngx-filesaver';
import {CommonService} from '../../../../services/apiServices/business/common.service';
import {FilterStatusTypeEnum, StatusErlEnum, StatusMailEnum} from "../../../../enums/filter.enums";
import {forkJoin} from "rxjs";
import {map} from "rxjs/operators";
import {Unsubscribable} from "../../../mixin/unsubscribable.component";


/**
 * Component that handleChangeOfSelectFold search (request back)
 */
@Component({
  selector: 'app-search',
  templateUrl: './search.component.html',
  styleUrls: ['./search.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class SearchComponent extends Unsubscribable(class {}) implements OnInit, OnDestroy {

  /**
   *
   * @param {SearchService} searchService
   * @param {TranslateService} translateService - useful because of Select (not translated inside template)
   * @param fileSaverService
   * @param storageService
   * @param commonService
   * @param {UpdateSearchFiltersService} updateSearchFiltersService -handle dynamic filters
   * @param authService
   */
  constructor(private searchService: SearchService,
              private translateService: TranslateService,
              private fileSaverService: FileSaverService,
              private storageService: StorageService,
              private commonService: CommonService,
              private updateSearchFiltersService: UpdateSearchFiltersService,
              private authService: AuthenticationService) {
    super();
  }
  @ViewChild('customPeriodCal', { static: false }) customPeriodCal: Calendar;

  /**
   * the list of criterias (User specific)
   */
  public criterias: SearchCriteria[];

  /**
   * List of dates(select)
   */
  public dateOptions: SelectItem[];
  public proofTypeOptions: SelectItem[];
  public statusTypeOptions: SelectItem[];
  public mailStatusTypeOptions: SelectItem[];
  public erlStatusTypeOptions: SelectItem[];

  /**
   * the selected option into the select (binding)
   */
  public selectedDateOption;

  /**
   * if usefull, the range of dates gave by the calendar
   */
  public selectedDates: Date[];

  /**
   * instance of the enum, only usefull in template for display purposes
   */
  public dateOptionsEnum = DateFiltered;

  /**
   * usefull to request deposit or sent items
   */
  public searchType: string;
  public proofType: string;
  public statusType: string;
  public mailType: string;
  public erlType: string;
  public searchTypes: SelectItem[];
  public searchDateType: string;
  public searchStatusType: string = FilterStatusTypeEnum.DISTRIBUTION;
  public searchDateTypes: SelectItem[];
  public searchStatusTypes: SelectItem[];
  /**
   * auto refresh variables
   */

  public timeLeft = 60;
  public interval;
  /**
   * usefull to status filter (processed or all)
   */
  public isProcessed: boolean;

  /**
   * binding (if option selected) to request a specific Week
   */
  public weekNumber: number;
  public weekLabel: string;

  /**
   * binding (if option selected) to request a specific Month
   */
  public monthNumber: number;

  /**
   *  message display when there's an error on request
   */
  private errorMessage: string;

  /**
   * title of message display when there's an error on request
   */
  private errorTitle: string;

  /**
   *  title of message display when there's no error on download request
   */
  private successDownloadTitle: string;

  /**
   *   message display when there's no error on download request
   */
  private successDownloadMessage: string;
  /**
   *  title of message display when there's no error on download request
   */
  private emptyDownloadTitle: string;

  /**
   *   message display when there's no error on download request
   */
  private emptyDownloadMessage: string;

  /**
   * if the search is not up to date, it'll be the displayed message
   */
  public notUpToDateMessage: string;

/*  /!**
   * for filter purpose
   *!/
  public sendNumber: string;

  /!**
   * for filter purpose
   *!/
  public depositNumber: string;*/

  /**
   * Enum ref : just useful for template access
   */
  public DateFiltered = DateFiltered;

  /**
   * currently active custom request
   */
  public currentRequestName: string;
  public yearRange=[new Date('2012-01-01'), new Date()];

  /**
   * If the user wants to save the request
   */
  public openAddOrUpdateSavedRequest: boolean;
  public openReportGenerator: boolean;
  public depositOnLabel: string;
  public depositOffLabel: string;
  public refreshOnLabel: string;
  public refreshOffLabel: string;
  public isProcessedOnLabel: string;
  public isProcessedOffLabel: string;
  private datePipe: DatePipe;
  public currentUser: User;
  public enableRefresh: boolean;
  public autoRefresh: boolean;
  public refreshLabels: Array<object>;
  public static pipeValueToFilterText(filter: string, value: string): string {
    let newValue = filter;
    if (newValue) {
      newValue = '' + newValue;
      if (newValue.indexOf(value) >= 0) {
        newValue = newValue.replace(value, '');
        newValue = newValue.replace('||', '|');
        if (newValue.startsWith('|')) {
          newValue = newValue.substring(1);
        }
        if (newValue.endsWith('|')) {
          newValue = newValue.substring(0, newValue.length - 1);
        }
      } else {
        if (newValue !== '') {
          newValue += '|';
        }
        newValue +=  value;
      }
    } else {
      newValue = value;
    }
    return newValue;
  }

  /**
   * determines if a criteria is a serial number (static use because of template)
   * @param {SearchCriteria} criteria - the inspected criteria
   * @return {boolean}
   */
  public static criteriaIsSendNumber(criteria: SearchCriteria): boolean {
    return SearchCriteria.criteriaIsSendNumber(criteria);
  }

  /**
   * determines if a criteria is a deposit number (static use because of template)
   * @param {SearchCriteria} criteria - the inspected criteria
   * @return {boolean}
   */
  public static criteriaIsDepositNumber(criteria: SearchCriteria): boolean {
    return SearchCriteria.criteriaIsDepositNumber(criteria);
  }

  /**
   * init values, and handleChangeOfSelectFold select dateOptions translation
   */
  public ngOnInit(): void {
    this.proofType = '';
    this.searchService.searchRequired.subscribe( val => {
      if (val) {
        this.search();
      }
    });
    this.datePipe = new DatePipe(this.translateService.currentLang);
    // reset on reload component (in case of log/delog)
    this.searchService.lastRequest = null;
    this.depositOnLabel = 'Envois';
    this.depositOffLabel = 'Dépots';
    this.isProcessedOnLabel = 'Traités';
    this.isProcessedOffLabel = 'Tous';

    this.translateService.get('SEARCH_COMPONENT.FORM.KIND_OF_SEARCH_DEPOSIT').subscribe(val => {
      this.depositOnLabel = val;
    });
    this.translateService.get('SEARCH_COMPONENT.FORM.KIND_OF_SEARCH_SENT').subscribe(val => {
      this.depositOffLabel = val;
    });
    this.translateService.get('COMMON.YES').subscribe(val => {
      this.refreshOnLabel = val;
    });
    this.translateService.get('COMMON.NO').subscribe(val => {
      this.refreshOffLabel = val;
    });
    this.translateService.get('COMMON.ROW_STATUS.SUCCESS').subscribe(val => {
      this.isProcessedOnLabel = val;
    });
    this.translateService.get('COMMON.ROW_STATUS.NONE').subscribe(val => {
      this.isProcessedOffLabel = val;
    });
    this.searchDateTypes = [];
    this.translateService.get('SEARCH_COMPONENT.FORM.TITLE_FILTER_DATE_ORDER').subscribe(label => {
      this.searchDateTypes.push({label: label, value: 'ORDER'});
    });
    this.translateService.get('SEARCH_COMPONENT.FORM.TITLE_FILTER_DATE_PROD').subscribe(label => {
      this.searchDateTypes.push({label: label, value: 'PRODUCTION'});
    });

    this.searchStatusTypes = [];

    const statusKeys = [
      { key: 'SEARCH_COMPONENT.STATUS.TITLE_FILTER_DISTRIBUTION', value: FilterStatusTypeEnum.DISTRIBUTION },
      { key: 'SEARCH_COMPONENT.STATUS.TITLE_FILTER_FOLD', value: FilterStatusTypeEnum.FOLD },
      { key: 'SEARCH_COMPONENT.STATUS.TITLE_FILTER_MAIL', value: FilterStatusTypeEnum.MAIL },
      { key: 'SEARCH_COMPONENT.STATUS.TITLE_FILTER_ERL', value: FilterStatusTypeEnum.ERL }
    ];

    forkJoin(
      statusKeys.map(status =>
        this.translateService.get(status.key).pipe(
          map(label => ({ label, value: status.value }))
        )
      )
    ).pipe(this.takeUntilDestroyed())
      .subscribe(translatedStatuses => {
      this.searchStatusTypes = translatedStatuses;
    });

    this.searchTypes = [];
    this.translateService.get('SEARCH_COMPONENT.FORM.SEARCH_TYPE_FOLDS').subscribe(label => {
      this.searchTypes.push({label: label, value: 'FOLDS'});
    });
    this.translateService.get('SEARCH_COMPONENT.FORM.SEARCH_TYPE_DEPOSIT').subscribe(label => {
      this.searchTypes.push({label: label, value: 'DEPOSITS'});
    });
    this.currentUser = this.authService.getCurrentUser();
    this.enableRefresh = false;
    this.autoRefresh = false;
    this.openAddOrUpdateSavedRequest = false;
    this.openReportGenerator = false;
    if (this.currentUser.permissions.webAutoRefresh.available) {
      this.enableRefresh = true;
    }
    this.autoRefresh = this.storageService.getAutoRefreshFromStorage(this.currentUser.idCustomer, this.currentUser.idUser) === true;
    this.updateAutoRefresh();
    registerLocaleData(localeFr, 'fr', localeFrExtra);
    registerLocaleData(localeEn, 'en', localeEnExtra);

    this.searchService.exposedCriterias.subscribe(result => {
      // console.log(result)
      this.criterias = result;
    });
    this.updateSearchFiltersService.depositNumber.subscribe(value => {
      const newValue = SearchComponent.pipeValueToFilterText(this.getDepositNumber(), value);
      for (const criteria of this.criterias) {
        if (SearchComponent.criteriaIsDepositNumber(criteria)) {
          setTimeout(() => {
            criteria.sCriteriaTrackingValue = newValue;
          }, 100);
        }
      }
    });

    this.updateSearchFiltersService.triggerSearch.subscribe(() => {
      this.search();
    });
    this.updateSearchFiltersService.sendNumber.subscribe(value => {
      const newValue = SearchComponent.pipeValueToFilterText(this.getSerialSentNumber(), value);
      for (const criteria of this.criterias) {
        if (SearchComponent.criteriaIsSendNumber(criteria)) {
          setTimeout(() => {
            criteria.sCriteriaTrackingValue = newValue;
          }, 100);
        }
      }
    });
    this.getTradForComponent();
    this.refreshLabels = [
      {label: this.refreshOnLabel, value: true },
      {label: this.refreshOffLabel, value: false }
    ];
  }
  /**
   * obtain translation from TranslateService
   */
  private getTradForComponent(): void {
    this.translateService.get('TOASTER.ERROR_MESSAGE_TITLE').subscribe((title: string) => {
      this.errorTitle = title;
    });
    this.translateService.get('TOASTER.FAIL_REQUEST').subscribe((message: string) => {
      this.errorMessage = message;
    });
    this.translateService.get('SEARCH_COMPONENT.MESSAGE.NOT_UP_TO_DATE').subscribe((message: string) => {
      this.notUpToDateMessage = message;
    });
    this.translateService.get('SEARCH_COMPONENT.PROOF').subscribe((proofTranslations) => {
      this.proofTypeOptions = [];
      this.proofTypeOptions.push({label: '', value: null});
      this.proofTypeOptions.push({label: proofTranslations.RADIO_NO_BACK, value: 'noBack'});
      this.proofTypeOptions.push({label: proofTranslations.RADIO_HAS_AR, value: 'hasAR'});
      this.proofTypeOptions.push({label: proofTranslations.RADIO_HAS_PND, value: 'hasPND'});
      this.proofTypeOptions.push({label: proofTranslations.RADIO_HAS_HISTO, value: 'hasHISTO'});
      this.proofTypeOptions.push({label: proofTranslations.RADIO_HAS_PLAT, value: 'hasPLAT'});
      this.proofTypeOptions.push({label: proofTranslations.RADIO_HAS_PLAT_RESPONSE, value: 'hasPLATResponse'});
      this.proofTypeOptions.push({label: proofTranslations.RADIO_IS_UNSUCCESSFUL_PLAT, value: 'isUnsuccessfulPLAT'});
      this.proofTypeOptions.push({label: proofTranslations.RADIO_IS_CERTIFICATE_PLAT, value: 'isCertificatePLAT'});
      this.proofTypeOptions.push({label: proofTranslations.RADIO_IS_CLAIMED_PLAT, value: 'isClaimedPLAT'});
      this.proofTypeOptions.push({label: proofTranslations.RADIO_IS_INTERNATIONAL_PLAT, value: 'isInternationalPLAT'});
    });
    this.translateService.get('SEARCH_COMPONENT.STATUS').subscribe((statusTranslations) => {
      this.statusTypeOptions = [];
      this.statusTypeOptions.push({label: '', value: null});
      this.statusTypeOptions.push({label: statusTranslations.SELECT_OPTIONS_WAITING, value: 'isWaiting'});
      this.statusTypeOptions.push({label: statusTranslations.SELECT_OPTIONS_PRINTED, value: 'isPrinted'});
      this.statusTypeOptions.push({label: statusTranslations.SELECT_OPTIONS_DISPATCHED, value: 'isDispatched'});
      this.statusTypeOptions.push({label: statusTranslations.SELECT_OPTIONS_DISCARDED, value: 'isDiscarded'});
      this.statusTypeOptions.push({label: statusTranslations.SELECT_OPTIONS_FAILED, value: 'isFailed'});
    });

    this.translateService.get('SEARCH_COMPONENT.ERL').subscribe((erlTranslations) => {
      this.erlStatusTypeOptions = [
        {label: '', value: null},
        {label: erlTranslations.LRE_CREATED, value: StatusErlEnum.isErlCreated},
        {label: erlTranslations.LRE_PLANNED, value: StatusErlEnum.isErlPlanned},
        {label: erlTranslations.LRE_REPLAYED, value: StatusErlEnum.isErlReplayed},
        {label: erlTranslations.LRE_SENT, value: StatusErlEnum.isErlLreSent},
        {label: erlTranslations.INJECTED, value: StatusErlEnum.isErlInjected},
        {label: erlTranslations.SENT, value: StatusErlEnum.isErlSent},
        {label: erlTranslations.PENDING, value: StatusErlEnum.isErlPending},
        {label: erlTranslations.FAILED, value: StatusErlEnum.isErlErlFailed},
        {label: erlTranslations.ACCEPTED, value: StatusErlEnum.isErlAccepted},
        {label: erlTranslations.REFUSED, value: StatusErlEnum.isErlRefused},
        {label: erlTranslations.EXPIRED, value: StatusErlEnum.isErlExpired},
        {label: erlTranslations.CLOSED, value: StatusErlEnum.isErlClosed},
        {label: erlTranslations.LRE_CANCELLED, value: StatusErlEnum.isErlLreCanceled},
        {label: erlTranslations.SEND_PAPER, value: StatusErlEnum.isErlSendPaper},
      ];
    });
    this.translateService.get('SEARCH_COMPONENT.MAIL').subscribe((mailTranslations) => {
      this.mailStatusTypeOptions = [
        {label: '', value: null},
        {label: mailTranslations.WAIT_SENDING, value: StatusMailEnum.isMailingWaitingSending},
        {label: mailTranslations.LINK_DOWNLOAD, value: StatusMailEnum.isMailingLinkDownload},
        {label: mailTranslations.LINK_CLICK, value: StatusMailEnum.isMailingLinkClick},
        {label: mailTranslations.PAPER, value: StatusMailEnum.isMailingPaper},
        {label: mailTranslations.REMINDER_SEND, value: StatusMailEnum.isMailingReminderSend},
        {label: mailTranslations.FAILED, value: StatusMailEnum.isMailingMailFailed},
        {label: mailTranslations.SEND_SUCCESS, value: StatusMailEnum.isMailingSendSuccess},
        {label: mailTranslations.IN_PROGRESS, value: StatusMailEnum.isMailingInProgress}
      ];
    });

    this.translateService.get('SEARCH_COMPONENT.DATE').subscribe((datesTranslations) => {
      this.dateOptions = [];
      this.dateOptions.push({label: ' ', value: null});
      this.dateOptions.push({label: datesTranslations.SELECT_OPTIONS_TODAY, value: DateFiltered.TODAY});
      this.dateOptions.push({label: datesTranslations.SELECT_OPTIONS_YESTERDAY, value: DateFiltered.YESTERDAY});
      this.dateOptions.push({label: datesTranslations.SELECT_OPTIONS_LAST_WEEK, value: DateFiltered.CURRENT_WEEK});
      this.dateOptions.push({label: datesTranslations.SELECT_OPTIONS_LAST_MONTH, value: DateFiltered.CURRENT_MONTH});
      this.dateOptions.push({label: datesTranslations.SELECT_OPTIONS_OTHER_WEEK, value: DateFiltered.OTHER_WEEK});
      this.dateOptions.push({label: datesTranslations.SELECT_OPTIONS_OTHER_MONTH, value: DateFiltered.OTHER_MONTH});
      this.dateOptions.push({label: datesTranslations.SELECT_OPTIONS_CUSTOM, value: DateFiltered.CUSTOM_PERIOD});
      this.setDefaultValues();
    });
    this.translateService.get('TOASTER.SUCCESS_MESSAGE_TITLE').subscribe((title: string) => {
      this.successDownloadTitle = title;
    });
    this.translateService.get('TOASTER.SUCCESS_DOWNLOAD_OK').subscribe((title: string) => {
      this.successDownloadMessage = title;
    });
    this.translateService.get('TOASTER.WARNING_MESSAGE_TITLE').subscribe((title: string) => {
      this.emptyDownloadTitle = title;
    });
    this.translateService.get('TOASTER.REQUEST_NO_RESULT').subscribe((title: string) => {
      this.emptyDownloadMessage = title;
    });
  }

  /**
   * init and reset values for form
   */
  public setDefaultValues(): void {
    this.selectedDates = null;
    this.weekNumber =  + this.datePipe.transform(new Date(), 'w', null, 'fr');
    this.updateWeekLabel();
    this.monthNumber =  + this.datePipe.transform(new Date(), 'M', null, 'fr');
    this.searchDateType = 'ORDER';
    this.searchType = 'FOLDS';
    this.isProcessed = false;
    this.selectedDateOption = this.dateOptionsEnum.TODAY;
    // this.startAutoRefresh();
  }

  /**
   *  (usefull when the user change the dateOptions inside select)
   */
  public resetDateOptionsValues(): void {
    this.selectedDates = null;
    this.weekNumber = + this.datePipe.transform(new Date(), 'w', null, 'fr');
    this.updateWeekLabel();
    this.monthNumber =  + this.datePipe.transform(new Date(), 'M', null, 'fr');
  }

  public hasCriteria(): boolean {
    for (const criteria of this.criterias) {
      if (criteria.sCriteriaTrackingValue !== null && criteria.sCriteriaTrackingValue !== '') {
        return true;
      }
    }
    return false;
  }
  /**
   * return true when user select at least one search criteria
   */
  public searchEnabled(): boolean {
    if (this.proofType !== '' && this.proofType !== null) {
      return true;
    }
    if (!this.selectedDateOption) {
      return this.hasCriteria();
    }
    else if (this.selectedDateOption === this.dateOptionsEnum.CUSTOM_PERIOD ) {
      return this.customPeriodEntryIsNotValid();
    }
     else {
      return true;
    }
  }
  /**
   * perform the search using searchService and handleChangeOfSelectFold error display
   */
  public search(): void {
    const searchOrderDate = this.searchDateType === 'ORDER';
    const isDeposit = this.searchType === 'DEPOSITS';
    this.searchService.search(this.criterias, this.selectedDateOption, isDeposit, this.proofType, this.statusType, this.mailType, this.erlType, searchOrderDate, this.getDateValue())
      .subscribe(res => {
        if (!res) {
          this.commonService.addToast({life: 3000, severity: 'error', summary: this.errorTitle, detail: this.errorMessage});
        }
    });
  }

  /**
   * Create a CSV file corresponding to the search
   */
  public exportAsCSV(): void {
    const searchOrderDate = this.searchDateType === 'ORDER';
    const isDeposit = this.searchType === 'DEPOSITS';
    this.searchService.export(this.criterias, this.selectedDateOption, isDeposit, this.proofType, this.statusType, this.mailType, this.erlType, searchOrderDate, this.getDateValue()).subscribe(response => {
      if (response.body.size > 0) {
        const blob = new Blob([ response.body ], {type: response.headers.get('content-type')});
        this.fileSaverService.save(blob, 'export_' + CustomDate.getFormatedToday() + '.csv');
        this.commonService.addToast({
          life: 3000,
          severity: 'success',
          summary: this.successDownloadTitle,
          detail: this.successDownloadMessage
        });
      }
      else {
        this.commonService.addToast({
          life: 3000,
          severity: 'warn',
          summary: this.emptyDownloadTitle,
          detail: this.emptyDownloadMessage
        });
      }
    });
  }

  /**
   *  Generate a report
   */
  public generateReport(): void {
    this.openReportGenerator = true;
  }
  /**
   * get the kind of date seized by user and
   * @return {any} - can be a kind of date (enum) or proper date Values
   */
  private getDateValue(): any {
    switch (this.selectedDateOption) {
      case DateFiltered.OTHER_WEEK:
        return this.weekNumber;

      case DateFiltered.OTHER_MONTH:
        return this.monthNumber;

      case DateFiltered.CUSTOM_PERIOD:
        this.makeSelectedDatesAcceptablesInEveryCase();
        return this.selectedDates;
      default:
        return null;
    }
  }
  public getDepositNumber(): string {
    for (const criteria of this.criterias) {
      if (SearchComponent.criteriaIsDepositNumber(criteria)) {
        return criteria.sCriteriaTrackingValue;
      }
    }
    return '';
  }
  public getSerialSentNumber(): string {
    for (const criteria of this.criterias) {
      if (SearchComponent.criteriaIsSendNumber(criteria)) {
        return criteria.sCriteriaTrackingValue;
      }
    }
    return '';
  }

  /**
   * Determine if a filter is pending a new search request
   *
   * @param {number} index - the index of the inspected filter
   * @return {boolean} - if the filter has changed: true else false
   */
/*  public filterFieldValueHasChanged(index: number): boolean {
    if (!this.searchService.lastRequest) {
      return false;
    }
    else {
      return !SearchCriteria.fieldValuesAreEquals(this.criterias[index].sCriteriaTrackingValue, this.searchService.lastRequest.criterias[index].sCriteriaTrackingValue);
    }
  }*/

  /**
   * Update criterias (when they're filled with a fieldValue) using id
   * Also used as double data binding for dynamic filters
   * @param {SearchCriteria} criteria - the source that will override itself into criterias
   */
/*  public criteriaChange(criteria: SearchCriteria): void {
/!*    if (this.criteriaIsDepositNumber(criteria)) {
      this.depositNumber = criteria.sCriteriaTrackingValue;
    } else if (this.criteriaIsSendNumber(criteria)) {
      this.sendNumber = criteria.sCriteriaTrackingValue;
    }*!/
    for (let i = 0; i < this.criterias.length; i++) {
      if (this.criterias[i].id === criteria.id) {
        this.criterias[i] = criteria;
      }
    }
  }*/

  /**
   * perform a little change on selectedDates (due to ngprime missing feature)
   */
  private makeSelectedDatesAcceptablesInEveryCase(): void {
    if (!this.selectedDates[1]) {
      this.selectedDates[1] = this.selectedDates[0];
    }
  }
  /**
   * Determine if the user selection for date is valid or not
   * @return {boolean} - user choice validity
   */
  public customPeriodEntryIsNotValid(): boolean {
    if (this.selectedDates) {
      return ((this.selectedDates[0] !== null) && (this.selectedDates[1] !== null));
    } else {
      return false;
    }
  }

  /**
   * set active request from child component (user-saved-request)
   * @param {any} request - the current selected request
   */
  public setActiveRequest(request: any): void {
    this.currentRequestName = request.requestName;
    const simpleFilters = request.simpleFilters;
    const advancedFilters = request.advancedFilters;

    if (simpleFilters || advancedFilters) {
      if (simpleFilters) {

        // Deposit or Sent Option
        this.searchType = simpleFilters.bLimitedDeposit ? 'DEPOSITS' : 'FOLDS';

        // Date Option
        this.selectedDateOption = '';
        if (simpleFilters.bDepotDay) {
          this.selectedDateOption = DateFiltered.TODAY;
        } else if (simpleFilters.bDepotYesterday) {
          this.selectedDateOption = DateFiltered.YESTERDAY;
        } else if (simpleFilters.bDepotWeek) {
          this.selectedDateOption = DateFiltered.CURRENT_WEEK;
        } else if (simpleFilters.bDepotMonth) {
          this.selectedDateOption = DateFiltered.CURRENT_MONTH;
        } else if (simpleFilters.iDepotMonthNum) {
          this.selectedDateOption = DateFiltered.OTHER_MONTH;
          this.monthNumber = simpleFilters.iDepotMonthNum;
        } else if (simpleFilters.iDepotWeekNum) {
          this.selectedDateOption = DateFiltered.OTHER_WEEK;
          this.weekNumber = simpleFilters.iDepotWeekNum;
        } else if (simpleFilters.dateDepotBegin && simpleFilters.dateDepotEnd) {
          this.selectedDateOption = DateFiltered.CUSTOM_PERIOD;
          this.selectedDates = [new Date(simpleFilters.dateDepotBegin), new Date(simpleFilters.dateDepotEnd)];
        }
      }
      else {
        this.setDefaultValues();
      }
      if (advancedFilters) {
        this.criterias.map(criteria => {
          for (const savedCriteria of advancedFilters) {
            if (criteria.sNameId === savedCriteria.sNameId) {
              criteria.sCriteriaTrackingValue = savedCriteria.sCriteriaTrackingValue;
            }
          }
        });

      }
      else {
        this.criterias.map(criteria => {
          criteria.sCriteriaTrackingValue = null;
        });
      }
    }
    else {
      this.setDefaultValues();
      this.criterias.map(criteria => {
        criteria.sCriteriaTrackingValue = null;
      });
    }
/*    const newArray: any = [];
    this.criterias.forEach((item) => {
      const t = Object.assign({}, item);
      newArray.push(t);
    });
    this.criterias = newArray;*/
  }
  public dateSelected(): void {
    if (this.selectedDateOption === this.dateOptionsEnum.CUSTOM_PERIOD) {
      if (this.selectedDates[0] && this.selectedDates[1]) {
        this.customPeriodCal.overlayVisible = false;
      }
    }
  }
  public updateAutoRefresh(): void {
    if (this.autoRefresh) {
      this.startAutoRefresh();
    }
    else {
      this.stopAutoRefresh();
    }
  }
  startAutoRefresh() {
    this.timeLeft = 60;
    clearInterval(this.interval);
    this.storageService.AddAutoRefreshToStorage(this.currentUser.idCustomer, this.currentUser.idUser, true);
    this.interval = setInterval(() => {
      if (this.timeLeft > 0) {
        this.timeLeft--;
      } else {
        this.search();
        this.timeLeft = 60;
      }
    }, 1000);
  }

  stopAutoRefresh() {
    clearInterval(this.interval);
    this.storageService.AddAutoRefreshToStorage(this.currentUser.idCustomer, this.currentUser.idUser, false);
  }

  override ngOnDestroy(): void {
    clearInterval(this.interval);
  }

  updateWeekLabel() {
    const nowDate = moment();
    nowDate.isoWeeks(this.weekNumber);
    this.weekLabel = '( ' +
      this.datePipe.transform(nowDate.startOf('isoWeek').toDate(), 'dd/MM', null, 'fr') +
      ' - ' +
      this.datePipe.transform(nowDate.endOf('isoWeek').toDate(), 'dd/MM', null, 'fr') + ' )';
  }
  public ensureSearchType(): void {
    if (this.searchDateType === 'PRODUCTION') {
      this.searchType = 'FOLDS';
    }
  }

  public changeFilterStatus(): void {
    switch(this.searchStatusType) {
      case FilterStatusTypeEnum.DISTRIBUTION: {
        this.statusType = null;
        this.mailType = null;
        this.erlType = null;
        break;
      }
      case FilterStatusTypeEnum.FOLD: {
        this.proofType = null;
        this.mailType = null;
        this.erlType = null;
        break;
      }
      case FilterStatusTypeEnum.MAIL: {
        this.proofType = null;
        this.statusType = null;
        this.erlType = null;
        break;
      }
      case FilterStatusTypeEnum.ERL: {
        this.proofType = null;
        this.statusType = null;
        this.mailType = null;
        break;
      }
      default : {
        this.proofType = null;
        this.statusType = null;
        this.mailType = null;
        this.erlType = null;
        break;
      }
    }
  }

  protected readonly FilterStatusTypeEnum = FilterStatusTypeEnum;
}

